module.exports = __webpack_public_path__ + "img/f5.40815704.png";